export default __webpack_public_path__ + "static/media/Flat_LightBlue.0bc596e9.png";